import { defaultMemoize } from 'reselect';

export default defaultMemoize(
  ({ error, isLoaded, isLoading }) =>
    !isLoading && (isLoaded || Boolean(error)),
);
